import * as React from 'react';
import cn from 'classnames';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';
import * as Styles from '../Icon.module.scss';

export const FamilyIcon = ({ fill = 'gcBlue', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);

    return (
        <svg
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                className={fillStyles}
                d="M12 14.0003C12.5523 14.0003 13 14.448 13 15.0003C12.9998 15.5524 12.5522 16.0003 12 16.0003H4C2.89543 16.0003 2 16.8957 2 18.0003V21.0003C1.99984 21.5525 1.55218 22.0003 1 22.0003C0.447817 22.0003 0.000164893 21.5525 0 21.0003V18.0003C0 15.7912 1.79086 14.0003 4 14.0003H12ZM20 16.0003C22.2091 16.0003 24 17.7912 24 20.0003V21.0003C23.9998 21.5525 23.5522 22.0003 23 22.0003C22.4478 22.0003 22.0002 21.5525 22 21.0003V20.0003C22 18.8957 21.1046 18.0003 20 18.0003H16C14.8954 18.0003 14 18.8957 14 20.0003V21.0003C13.9998 21.5525 13.5522 22.0003 13 22.0003C12.4478 22.0003 12.0002 21.5525 12 21.0003V20.0003C12 17.7912 13.7909 16.0003 16 16.0003H20ZM18 7.00031C20.2091 7.00031 22 8.79117 22 11.0003C21.9998 13.2093 20.209 15.0003 18 15.0003C15.791 15.0003 14.0002 13.2093 14 11.0003C14 8.79117 15.7909 7.00031 18 7.00031ZM18 9.00031C16.8954 9.00031 16 9.89574 16 11.0003C16.0002 12.1047 16.8955 13.0003 18 13.0003C19.1045 13.0003 19.9998 12.1047 20 11.0003C20 9.89574 19.1046 9.00031 18 9.00031ZM7.75 3.00031C10.3734 3.00031 12.5 5.12695 12.5 7.75031C12.4998 10.3735 10.3733 12.5003 7.75 12.5003C5.12675 12.5003 3.00016 10.3735 3 7.75031C3 5.12695 5.12665 3.00031 7.75 3.00031ZM7.75 5.00031C6.23122 5.00031 5 6.23152 5 7.75031C5.00016 9.26895 6.23132 10.5003 7.75 10.5003C9.26868 10.5003 10.4998 9.26895 10.5 7.75031C10.5 6.23152 9.26878 5.00031 7.75 5.00031Z"
            />
        </svg>
    );
};
